<main class="flex-1">
    <!-- Hero Section -->
    <div class="relative overflow-hidden bg-gradient-to-br from-indigo-900 via-blue-800 to-indigo-800 text-white">
        <div class="absolute inset-0">
            <div class="absolute inset-0 bg-[url('/assets/images/grid-pattern.svg')] opacity-20"></div>
            <div class="absolute inset-0 bg-gradient-to-t from-indigo-900/80 via-transparent to-transparent"></div>
        </div>
        <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
            <div class="grid lg:grid-cols-2 gap-12 items-center">
                <div>
                    <div class="inline-flex items-center px-4 py-2 rounded-full bg-blue-500/10 text-blue-400 mb-6">
                        <span class="w-2 h-2 rounded-full bg-orange-400 animate-pulse mr-2"></span>
                        <span class="text-sm font-semibold">25+ years of trusted market intelligence expertise</span>
                    </div>
                    <h1 class="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-6">
                        Relevant Market <span class="text-blue-400">Intelligence</span> at your fingertips
                    </h1>
                    <p class="text-xl text-blue-200 mb-4 font-medium">
                        Transform data into strategic business decisions
                    </p>
                    <p class="text-lg text-gray-300 mb-8">
                        Our dedicated team of industry experts delivers personalized insights on legislation, competitors, and market trends tailored specifically to your business needs, helping you make informed strategic decisions.
                    </p>
                    <div class="flex flex-col sm:flex-row gap-4">
                        <a href="#company-history" class="custom-button inline-flex items-center justify-center px-6 py-3.5 text-base font-medium rounded-lg bg-transparent hover:bg-white/10 text-white border border-white/20 transition-all hover:border-white/40 focus:ring-2 focus:ring-white/30 focus:outline-none" aria-label="Learn about our company history and expertise">
                            Discover Our Expertise
                        </a>
                        <a href="/demo" class="custom-button inline-flex items-center justify-center px-6 py-3.5 text-base font-medium rounded-lg bg-blue-500 hover:bg-blue-600 text-white transition-all shadow-md hover:shadow-lg focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-blue-900 focus:outline-none" aria-label="Browse our interactive demos and solutions">
                            Explore Demo Catalog
                            <svg class="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/>
                            </svg>
                        </a>
                    </div>
                    <div class="mt-8 flex items-center gap-5">
                        <div class="flex -space-x-3">
                            <img src="https://industryintel.s3.us-west-2.amazonaws.com/assets/images/clientlogo/dowchemical.png" class="w-12 h-12 rounded-full bg-white p-1.5 border-2 border-white object-contain shadow-sm" title="Dow Chemical" alt="Dow Chemical">
                            <img src="https://industryintel.s3.us-west-2.amazonaws.com/assets/images/clientlogo/berryglobal.png" class="w-12 h-12 rounded-full bg-white p-1.5 border-2 border-white object-contain shadow-sm" title="Berry Global, Inc." alt="Berry Global, Inc.">
                            <img src="https://industryintel.s3.us-west-2.amazonaws.com/assets/images/clientlogo/pca.png" class="w-12 h-12 rounded-full bg-white p-1.5 border-2 border-white object-contain shadow-sm" title="Packaging Corporation of America" alt="Packaging Corporation of America">
                        </div>
                        <p class="text-sm md:text-base text-gray-400">
                            Trusted by <span class="font-semibold text-white">2,000+</span> industry leaders
                        </p>
                    </div>
                </div>
                <div class="relative group">
                    <!-- Main video container with enhanced styling -->
                    <div class="relative rounded-xl overflow-hidden shadow-2xl bg-gradient-to-br from-blue-900 to-indigo-800 transition-all duration-500 transform group-hover:shadow-blue-500/20 group-hover:shadow-xl border border-blue-800/30">
                        <video id="video1" style="width:100%;height:100%;" controls autoplay muted loop playsinline>
                            <source src="https://s3.industryintel.com/publicpromo/promo-main.mp4" type="video/mp4">
                            <!-- Fallback content if video isn't supported -->
                            <div class="flex items-center justify-center h-64 bg-gradient-to-br from-blue-900 to-indigo-800 text-white">
                                <div class="text-center">
                                    <svg class="w-16 h-16 mx-auto text-white/80" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M8 5v14l11-7z"></path>
                                    </svg>
                                    <p class="mt-2">Video content unavailable</p>
                                </div>
                            </div>
                        </video>
                    </div>

                    <!-- Video caption -->
                    <div class="mt-3 text-center">
                        <p class="text-sm text-blue-400 font-medium">Watch how we transform data into strategic advantage</p>
                    </div>

                    <!-- Stats Cards - Repositioned with connecting elements -->
                    <div class="absolute -top-16 -left-16 bg-gray-900/80 backdrop-blur-sm rounded-full shadow-xl py-2 px-4 border border-blue-500/30 z-10 flex items-center gap-3 hover:border-blue-500/70 transition-all duration-300 hidden md:flex">
                        <div class="bg-blue-500/20 rounded-full p-1.5">
                            <svg class="w-5 h-5 text-blue-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.33008 14.49L9.71008 11.4C10.0501 10.96 10.6801 10.88 11.1201 11.22L12.9501 12.66C13.3901 13 14.0201 12.92 14.3601 12.49L16.6701 9.51001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <p class="text-xs font-medium text-gray-400">Industry Expertise</p>
                            <p class="text-sm font-bold text-white">25+ Industries</p>
                        </div>
                        <!-- Connecting line to video -->
                        <div class="absolute top-full left-1/2 w-px h-8 bg-gradient-to-b from-blue-500/70 to-transparent"></div>
                    </div>
                    
                    <div class="absolute -bottom-16 -right-16 bg-gray-900/80 backdrop-blur-sm rounded-full shadow-xl py-2 px-4 border border-green-500/30 z-10 flex items-center gap-3 hover:border-green-500/70 transition-all duration-300 hidden md:flex">
                        <div class="bg-green-500/20 rounded-full p-1.5">
                            <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <div>
                            <p class="text-xs font-medium text-gray-400">Service Delivery</p>
                            <p class="text-sm font-bold text-white">Daily Insights</p>
                        </div>
                        <!-- Connecting line to video -->
                        <div class="absolute bottom-full right-1/2 w-px h-8 bg-gradient-to-t from-green-500/70 to-transparent"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Announcement Bar -->
        @if (announcement) {
            <div class="relative bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="py-3 flex items-center justify-between">
                        <div class="flex items-center">
                            <i class="fas fa-sparkles mr-2"></i>
                            <span class="font-medium">{{ announcement.title }}</span>
                        </div>
                        <a [routerLink]="announcement.ctaUrl" class="text-sm font-medium hover:text-blue-100 flex items-center gap-1 transition-colors group">
                            {{ announcement.ctaText }}
                            <i class="fas fa-arrow-right transform transition-transform duration-300 group-hover:translate-x-1"></i>
                        </a>
                    </div>
                </div>
            </div>
        }
    </div>

    <!-- Client Logo Section - Modern Redesign -->
    <div class="bg-gray-50 py-20 overflow-hidden">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center mb-12">
                <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">Trusted by <span class="text-blue-600">Industry</span> Leaders</h2>
                <p class="text-lg text-gray-600 max-w-2xl mx-auto">
                    Join over 2,000+ forward-thinking companies making data-driven decisions with our expertise
                </p>
            </div>
            
            <!-- Logo Grid with Fade Effect -->
            <div class="relative logo-marquee">
                <!-- Gradient Overlays - Only for Logo Section -->
                <div class="absolute left-0 top-0 bottom-0 w-[100px] bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
                <div class="absolute right-0 top-0 bottom-0 w-[200px] bg-gradient-to-l from-gray-50 via-gray-50/50 via-gray-50/30 to-transparent z-10"></div>
                
                <!-- First Row -->
                <div class="relative flex overflow-hidden">
                    <div class="flex animate-marquee">
                        <div class="flex shrink-0 w-fit logo-container">
                            @for (logo of logos; track logo.name) {
                                <div class="flex-none mx-8 w-36 h-24 flex items-center justify-center opacity-80 hover:opacity-100 transition-all duration-300 logo-item">
                                    <img [src]="logo.imageURL" [alt]="logo.name" [title]="logo.name" class="max-h-16 max-w-full object-contain">
                                </div>
                            }
                        </div>
                        <div class="flex shrink-0 w-fit logo-container">
                            @for (logo of logos; track logo.name) {
                                <div class="flex-none mx-8 w-36 h-24 flex items-center justify-center opacity-80 hover:opacity-100 transition-all duration-300 logo-item">
                                    <img [src]="logo.imageURL" [alt]="logo.name" [title]="logo.name" class="max-h-16 max-w-full object-contain">
                                </div>
                            }
                        </div>
                    </div>
                </div>
                
                <!-- Second Row -->
                <div class="relative flex overflow-hidden mt-12">
                    <div class="flex animate-marquee-reverse">
                        <div class="flex shrink-0 w-fit logo-container">
                            @for (logo of logos.slice().reverse(); track logo.name) {
                                <div class="flex-none mx-8 w-36 h-24 flex items-center justify-center opacity-80 hover:opacity-100 transition-all duration-300 logo-item">
                                    <img [src]="logo.imageURL" [alt]="logo.name" [title]="logo.name" class="max-h-16 max-w-full object-contain">
                                </div>
                            }
                        </div>
                        <div class="flex shrink-0 w-fit logo-container">
                            @for (logo of logos.slice().reverse(); track logo.name) {
                                <div class="flex-none mx-8 w-36 h-24 flex items-center justify-center opacity-80 hover:opacity-100 transition-all duration-300 logo-item">
                                    <img [src]="logo.imageURL" [alt]="logo.name" [title]="logo.name" class="max-h-16 max-w-full object-contain">
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Company History Section -->
    <section id="company-history" class="py-20 bg-white">
        <div class="container mx-auto px-4">
            <!-- Section Header -->
            <div class="text-center max-w-3xl mx-auto mb-16">
                <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">Our <span class="text-blue-600">Company</span> History</h2>
                <p class="text-xl text-gray-600">{{ companyHistory.description }}</p>
            </div>

            <!-- Desktop Timeline (hidden on mobile) -->
            <div class="hidden md:block relative">
                <!-- The main timeline line -->
                <div class="absolute left-0 right-0 h-1 top-1/2 transform -translate-y-1/2 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full"></div>

                <!-- Timeline Items Container -->
                <div class="grid grid-cols-5 gap-8 relative">
                    @for (milestone of companyHistory.milestones; track milestone.year) {
                        <div class="flex flex-col items-center">
                            <!-- Year Circle with Shadow -->
                            <div class="w-16 h-16 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold mb-6 relative z-10 shadow-lg">
                                {{ milestone.year }}
                            </div>
                            
                            <!-- Milestone Content -->
                            <div class="text-center bg-white rounded-xl p-6 shadow-md border border-gray-100 h-full w-full">
                                <h3 class="text-xl font-bold text-gray-900 mb-2">{{ milestone.title }}</h3>
                                <p class="text-gray-600">{{ milestone.description }}</p>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <!-- Mobile Timeline (shown only on mobile) -->
            <div class="md:hidden">
                <div class="relative pl-10">
                    <!-- The vertical timeline line -->
                    <div class="absolute left-4 inset-y-0 w-1 bg-gradient-to-b from-blue-500 to-indigo-600 rounded-full"></div>

                    @for (milestone of companyHistory.milestones; track milestone.year) {
                        <div class="mb-10 relative">
                            <!-- Connector dot on timeline -->
                            <div class="absolute left-4 top-0 w-2 h-2 rounded-full bg-white border-4 border-blue-500 transform -translate-x-1/2 z-10"></div>
                            
                            <!-- Year Circle -->
                            <div class="absolute left-0 top-0 transform -translate-x-1/2 w-14 h-14 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold shadow-md z-20">
                                {{ milestone.year }}
                            </div>
                            
                            <!-- Content Box -->
                            <div class="bg-white rounded-xl p-6 shadow-md border border-gray-100 ml-4">
                                <h3 class="text-lg font-bold text-gray-900 mb-2">{{ milestone.title }}</h3>
                                <p class="text-gray-600 text-sm">{{ milestone.description }}</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </section>

    <!-- Products Overview Section - Redesigned for Cohesion -->
    <div class="bg-gray-50 py-20">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <!-- Section Header -->
            <div class="text-center mb-16">
                <div class="inline-flex items-center px-4 py-1.5 rounded-full bg-indigo-100 text-indigo-800 text-sm font-medium mb-4 shadow-sm">
                    <span class="w-2 h-2 rounded-full bg-indigo-500 mr-2"></span>
                    <span>PRODUCTS OVERVIEW</span>
                </div>
                <h2 class="mt-2 text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">Explore Our Market <span class="text-blue-600">Intelligence</span> Products</h2>
                <p class="text-lg text-gray-600 max-w-3xl mx-auto">
                    Discover a range of innovative tools designed to deliver actionable insights and transform your business decisions.
                </p>
            </div>
            
            <!-- Product Grid - Unified Design -->
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-16">
                <!-- Featured Product - Legislation Monitor -->
                <div class="lg:col-span-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl overflow-hidden shadow-md border border-blue-100 mb-8">
                    <div class="grid md:grid-cols-2 gap-8 p-8">
                        <div>
                            <div class="inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-xs font-medium mb-4">
                                FEATURED PRODUCT
                            </div>
                            <h3 class="text-2xl font-bold text-gray-900 mb-4">The Latest Legislative Information at Your Fingertips</h3>
                            <p class="text-gray-700 mb-6">This must-have weekly report provides business leaders with accurate, up-to-date information on legislative developments at the federal and state levels. Written with business in mind and free of technical jargon, users can quickly grasp essential information to make the best, most informed business decisions to stay ahead of changing regulations.</p>
                            
                            <div class="grid grid-cols-2 gap-4 mb-8">
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                    <span class="text-gray-700">Comprehensive insight: From bills to statutes, with bill history and sponsor tracking</span>
                                </div>
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                    <span class="text-gray-700">Relevant summaries: AI-powered dashboard breaks down significance of each update</span>
                                </div>
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                    <span class="text-gray-700">Industry relevance: Quickly investigate updates using industry-specific categories</span>
                                </div>
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                    <span class="text-gray-700">360-degree connections: Links legislative updates with related news and analysis</span>
                                </div>
                            </div>
                            
                            <a [routerLink]="products[0].link" 
                               class="inline-flex items-center px-5 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-all">
                                Learn more
                                <svg class="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                                </svg>
                            </a>
                        </div>
                        
                        <div class="relative">
                            <div class="rounded-xl overflow-hidden shadow-md h-full">
                                <img [src]="products[0].image" [alt]="products[0].imageAlt" class="w-full h-full object-cover">
                                <div class="absolute inset-0 bg-gradient-to-tr from-blue-900/20 to-transparent"></div>
                            </div>
                            
                            <!-- New badge -->
                            <div class="absolute -bottom-3 -right-3 bg-blue-600 text-white px-3 py-1.5 rounded-lg shadow-md text-sm font-medium">
                                New
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Intelligence Triad Products -->
                @for (product of products.slice(1, 4); track product.title) {
                    <div class="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 overflow-hidden flex flex-col group">
                        <div class="aspect-video bg-gray-100 relative">
                            <img [src]="product.image" [alt]="product.imageAlt" class="w-full h-full object-cover">
                            <div class="absolute inset-0 bg-gradient-to-t from-gray-900/70 to-transparent"></div>
                            <div class="absolute bottom-3 left-3 right-3">
                                <div class="text-xs font-medium text-blue-200 mb-1">{{ product.category }}</div>
                                <div class="text-lg font-bold text-white">{{ product.title }}</div>
                            </div>
                        </div>
                        
                        <div class="p-6 flex-1 flex flex-col">
                            <p class="text-gray-700 mb-4 flex-1">{{ product.description.split('.')[0] }}.</p>
                            
                            <ul class="mb-6 space-y-2">
                                @for (feature of (product.features || []).slice(0, 2); track feature) {
                                    <li class="flex items-start">
                                        <svg class="w-4 h-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        <span class="text-sm text-gray-600">{{ feature }}</span>
                                    </li>
                                }
                            </ul>
                            
                            <a [routerLink]="product.link" class="mt-auto text-sm font-medium text-blue-600 hover:text-blue-800 inline-flex items-center group">
                                Learn more
                                <svg class="ml-1 w-4 h-4 transform transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                                </svg>
                            </a>
                        </div>
                    </div>
                }
                
                <!-- Complimentary Product - Full Width -->
                <div class="lg:col-span-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl overflow-hidden shadow-sm border border-blue-100 mt-4">
                    <div class="p-8">
                        <div class="flex flex-col md:flex-row gap-8 items-center">
                            <div class="md:w-1/4">
                                <div class="inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-xs font-medium mb-2">
                                    COMPLEMENTARY SUBSCRIPTION
                                </div>
                                <h4 class="text-xl font-bold text-gray-900 mb-2">Executive Summary</h4>
                                <div class="aspect-video bg-white rounded-lg overflow-hidden shadow-md relative md:hidden mb-4">
                                    <img [src]="products[4].image" [alt]="products[4].imageAlt" class="w-full h-full object-cover">
                                </div>
                                <p class="text-gray-700">Premium intelligence for strategic decision-makers</p>
                            </div>
                            
                            <div class="md:w-2/4">
                                <div class="grid grid-cols-1 gap-3 mb-4">
                                    <div class="flex items-start">
                                        <svg class="w-4 h-4 text-blue-500 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        <span class="text-sm text-gray-700"><span class="font-medium text-gray-900">Weekly Executive Brief:</span> Curated news about market transformations, innovations, and insights from top executives, distilled into a concise recap.</span>
                                    </div>
                                    <div class="flex items-start">
                                        <svg class="w-4 h-4 text-blue-500 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        <span class="text-sm text-gray-700"><span class="font-medium text-gray-900">AI-Powered Economy Update:</span> Economic indicators and AI-generated analysis to navigate market opportunities and challenges effectively.</span>
                                    </div>
                                    <div class="flex items-start">
                                        <svg class="w-4 h-4 text-blue-500 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                        </svg>
                                        <span class="text-sm text-gray-700"><span class="font-medium text-gray-900">360-Degree Market Watch:</span> Our proprietary "Always On" monitoring system tracks evolving market news as it happens.</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="md:w-1/4 flex flex-col items-center">
                                <div class="aspect-video bg-white rounded-lg overflow-hidden shadow-md relative w-full hidden md:block mb-4">
                                    <img [src]="products[4].image" [alt]="products[4].imageAlt" class="w-full h-full object-cover">
                                </div>
                                <a [routerLink]="products[4].link" 
                                   class="w-full inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-all">
                                    Learn more
                                    <svg class="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- CTA Section -->
            <div class="text-center">
                <a href="#contact" class="inline-flex items-center px-6 py-3.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-all duration-300 shadow-md hover:shadow-lg focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none">
                    Experience Our Interactive Demos
                    <svg class="ml-2 w-5 h-5 transform transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                    </svg>
                </a>
            </div>
        </div>
    </div>

    <!-- Solutions Overview Section -->
    <div class="bg-white py-20 relative overflow-hidden">
        <!-- Subtle background pattern -->
        <div class="absolute inset-0">
            <div class="absolute inset-0 bg-[url('/assets/images/grid-pattern.svg')] opacity-5"></div>
            <div class="absolute inset-0 bg-gradient-to-b from-blue-50/50 via-transparent to-transparent"></div>
        </div>
        <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center mb-16">
                <div class="inline-flex items-center px-4 py-1.5 rounded-full bg-indigo-100 text-indigo-800 text-sm font-medium mb-4 shadow-sm">
                    <span class="w-2 h-2 rounded-full bg-indigo-500 mr-2"></span>
                    <span>SOLUTIONS OVERVIEW</span>
                </div>
                <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">Intelligence at Your <span class="text-blue-600">Fingertips</span></h2>
                <p class="text-xl text-gray-600 max-w-3xl mx-auto">
                    Access targeted insights across multiple industries with our intuitive solutions, designed for seamless integration into your workflow
                </p>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <!-- Left Column: Solution Categories -->
                <div class="space-y-6">
                    <!-- Regulatory Monitoring -->
                    <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1">
                        <div class="flex items-center justify-between mb-4">
                            <h3 class="text-xl font-bold text-gray-900">
                                {{ solutions.regulatory.title }}
                            </h3>
                            <div class="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center shadow-sm">
                                <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                                </svg>
                            </div>
                        </div>
                        <p class="text-gray-600 mb-5">
                            {{ solutions.regulatory.description }}
                        </p>
                        <div class="flex items-start mb-3">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.regulatory.features[0] }}</span>
                        </div>
                        <div class="flex items-start">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.regulatory.features[1] }}</span>
                        </div>
                    </div>

                    <!-- Customer Insight -->
                    <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1">
                        <div class="flex items-center justify-between mb-4">
                            <h3 class="text-xl font-bold text-gray-900">
                                {{ solutions.customer.title }}
                            </h3>
                            <div class="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center shadow-sm">
                                <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                                </svg>
                            </div>
                        </div>
                        <p class="text-gray-600 mb-5">
                            {{ solutions.customer.description }}
                        </p>
                        <div class="flex items-start mb-3">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.customer.features[0] }}</span>
                        </div>
                        <div class="flex items-start">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.customer.features[1] }}</span>
                        </div>
                    </div>

                    <!-- Competitive Analysis -->
                    <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1">
                        <div class="flex items-center justify-between mb-4">
                            <h3 class="text-xl font-bold text-gray-900">
                                {{ solutions.competitive.title }}
                            </h3>
                            <div class="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center shadow-sm">
                                <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                                </svg>
                            </div>
                        </div>
                        <p class="text-gray-600 mb-5">
                            {{ solutions.competitive.description }}
                        </p>
                        <div class="flex items-start mb-3">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.competitive.features[0] }}</span>
                        </div>
                        <div class="flex items-start">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.competitive.features[1] }}</span>
                        </div>
                    </div>

                    <!-- Supply Chain Insights -->
                    <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1">
                        <div class="flex items-center justify-between mb-4">
                            <h3 class="text-xl font-bold text-gray-900">
                                {{ solutions.supplyChain.title }}
                            </h3>
                            <div class="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center shadow-sm">
                                <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18"></path>
                                </svg>
                            </div>
                        </div>
                        <p class="text-gray-600 mb-5">
                            {{ solutions.supplyChain.description }}
                        </p>
                        <div class="flex items-start mb-3">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.supplyChain.features[0] }}</span>
                        </div>
                        <div class="flex items-start">
                            <div class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center mr-2">
                                <svg class="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <span class="text-sm text-gray-700">{{ solutions.supplyChain.features[1] }}</span>
                        </div>
                    </div>
                </div>
                
                <!-- Right Column: Featured Solution - Market Intelligence -->
                <div class="bg-gradient-to-br from-blue-900 to-indigo-800 rounded-2xl overflow-hidden shadow-xl h-full relative">
                    <!-- Enhanced decorative elements with better positioning and size -->
                    <div class="absolute top-10 right-10 w-64 h-64 rounded-full bg-blue-600/20 blur-3xl z-0"></div>
                    <div class="absolute bottom-10 left-10 w-56 h-56 rounded-full bg-indigo-500/20 blur-3xl z-0"></div>
                    <div class="absolute top-40 left-20 w-40 h-40 rounded-full bg-blue-400/15 blur-3xl z-0"></div>
                    
                    <div class="p-8 md:p-10 h-full flex flex-col relative z-10">
                        <div class="inline-flex items-center px-3 py-1 rounded-full bg-white/20 text-white text-sm font-medium mb-6">
                            <span class="w-2 h-2 rounded-full bg-orange-400 animate-pulse mr-2"></span>
                            FEATURED SOLUTION
                        </div>
                        <h3 class="text-3xl font-bold text-white mb-4">Market Intelligence</h3>
                        <p class="text-blue-100 mb-8">
                            Get real-time insights on market trends, pricing dynamics, and industry developments to stay ahead of the competition.
                        </p>
                        
                        <!-- Subtle divider with animation -->
                        <div class="w-16 h-1 bg-blue-400/40 rounded-full mb-8 hover:w-24 transition-all duration-500"></div>
                        
                        <!-- Feature grid with enhanced styling -->
                        <div class="grid grid-cols-2 gap-8 mb-0">
                            <!-- Industry trend analysis -->
                            <div class="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:border-white/40 transition-all duration-300 shadow-sm hover:shadow-lg group">
                                <div class="flex flex-col items-center text-center">
                                    <div class="flex-shrink-0 w-16 h-16 rounded-full bg-blue-500/30 flex items-center justify-center mb-5 shadow-inner group-hover:bg-blue-500/40 transition-all">
                                        <svg class="w-8 h-8 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 class="text-white font-medium text-lg mb-3">Industry Trends</h4>
                                        <p class="text-blue-200 text-sm">Comprehensive analysis of emerging patterns and market developments</p>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Pricing intelligence -->
                            <div class="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:border-white/40 transition-all duration-300 shadow-sm hover:shadow-lg group">
                                <div class="flex flex-col items-center text-center">
                                    <div class="flex-shrink-0 w-16 h-16 rounded-full bg-blue-500/30 flex items-center justify-center mb-5 shadow-inner group-hover:bg-blue-500/40 transition-all">
                                        <svg class="w-8 h-8 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 class="text-white font-medium text-lg mb-3">Pricing Intelligence</h4>
                                        <p class="text-blue-200 text-sm">Real-time market pricing data and competitive analysis</p>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Market share tracking -->
                            <div class="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:border-white/40 transition-all duration-300 shadow-sm hover:shadow-lg group">
                                <div class="flex flex-col items-center text-center">
                                    <div class="flex-shrink-0 w-16 h-16 rounded-full bg-blue-500/30 flex items-center justify-center mb-5 shadow-inner group-hover:bg-blue-500/40 transition-all">
                                        <svg class="w-8 h-8 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 class="text-white font-medium text-lg mb-3">Market Share</h4>
                                        <p class="text-blue-200 text-sm">Competitive positioning metrics and industry benchmarks</p>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Growth opportunity identification -->
                            <div class="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:border-white/40 transition-all duration-300 shadow-sm hover:shadow-lg group">
                                <div class="flex flex-col items-center text-center">
                                    <div class="flex-shrink-0 w-16 h-16 rounded-full bg-blue-500/30 flex items-center justify-center mb-5 shadow-inner group-hover:bg-blue-500/40 transition-all">
                                        <svg class="w-8 h-8 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <h4 class="text-white font-medium text-lg mb-3">Growth Opportunities</h4>
                                        <p class="text-blue-200 text-sm">Identify emerging market potential and expansion strategies</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Stats Section with Testimonials -->
    <div class="relative py-20 bg-gradient-to-br from-indigo-900 via-blue-800 to-indigo-800 overflow-hidden">
        <div class="absolute inset-0">
            <div class="absolute inset-0 bg-[url('/assets/images/grid-pattern.svg')] opacity-15"></div>
            <div class="absolute inset-0 bg-gradient-to-t from-blue-900/50 via-transparent to-transparent"></div>
        </div>
        <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center mb-16">
                <div class="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-500/20 text-blue-200 text-sm font-medium mb-4 shadow-sm">
                    <span class="w-2 h-2 rounded-full bg-blue-400 mr-2"></span>
                    <span>CLIENT SUCCESS</span>
                </div>
                <h2 class="text-3xl lg:text-4xl font-bold text-white sm:text-4xl mb-6 leading-tight">Proven <span class="text-blue-400">Results</span> That Speak Volumes</h2>
                <p class="mt-4 text-xl text-gray-300">
                    See how our platform empowers organizations to achieve measurable success
                </p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
                <!-- Legislations Tracked -->
                <div class="hover-card relative group p-8 bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20 hover:-translate-y-1">
                    <div class="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-blue-600/30 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                    <div class="relative">
                        <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-blue-500/20 text-blue-400">
                            <!-- Chart Bar Icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="3" y="12" width="4" height="8" rx="1"></rect>
                                <rect x="10" y="8" width="4" height="12" rx="1"></rect>
                                <rect x="17" y="4" width="4" height="16" rx="1"></rect>
                            </svg>
                        </div>
                        <div class="text-4xl font-bold text-white mb-2 text-center group-hover:text-blue-300 transition-colors">500K+</div>
                        <div class="text-sm font-medium text-gray-400 uppercase tracking-wide text-center">LEGISLATIONS TRACKED</div>
                    </div>
                </div>

                <!-- News Articles Analyzed -->
                <div class="hover-card relative group p-8 bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/20 hover:-translate-y-1">
                    <div class="absolute inset-0 bg-gradient-to-br from-green-500/20 to-green-600/30 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                    <div class="relative">
                        <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-green-500/20 text-green-400">
                            <!-- Trending Up Icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                                <polyline points="17 6 23 6 23 12"></polyline>
                            </svg>
                        </div>
                        <div class="text-4xl font-bold text-white mb-2 text-center group-hover:text-green-300 transition-colors">100M+</div>
                        <div class="text-sm font-medium text-gray-400 uppercase tracking-wide text-center">NEWS ARTICLES ANALYZED</div>
                    </div>
                </div>

                <!-- Daily Insights -->
                <div class="hover-card relative group p-8 bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20 hover:-translate-y-1">
                    <div class="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-purple-600/30 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                    <div class="relative">
                        <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-purple-500/20 text-purple-400">
                            <!-- Lightning Bolt Icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                            </svg>
                        </div>
                        <div class="text-4xl font-bold text-white mb-2 text-center group-hover:text-purple-300 transition-colors">50K+</div>
                        <div class="text-sm font-medium text-gray-400 uppercase tracking-wide text-center">DAILY INSIGHTS</div>
                    </div>
                </div>

                <!-- Client Satisfaction -->
                <div class="hover-card relative group p-8 bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/20 hover:-translate-y-1">
                    <div class="absolute inset-0 bg-gradient-to-br from-yellow-500/20 to-yellow-600/30 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                    <div class="relative">
                        <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-yellow-500/20 text-yellow-400">
                            <!-- Star Icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                            </svg>
                        </div>
                        <div class="text-4xl font-bold text-white mb-2 text-center group-hover:text-yellow-300 transition-colors">98%</div>
                        <div class="text-sm font-medium text-gray-400 uppercase tracking-wide text-center">CLIENT SATISFACTION</div>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                @if (landingPageTestimonials$ | async; as testimonials) {
                    @for (testimonial of testimonials; track testimonial.id) {
                        <div class="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-white/10 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1 flex flex-col h-full">
                            <div class="text-blue-400 text-4xl mb-4">
                                <svg class="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"></path>
                                </svg>
                            </div>
                            <p class="text-gray-200 mb-6 italic overflow-y-auto max-h-48">{{testimonial.quote}}</p>
                            
                            <div class="mt-auto pt-4 border-t border-white/10">
                                <div class="flex flex-col">
                                    <h4 class="font-bold text-white text-lg">{{testimonial.genericTitle}}</h4>
                                    <p class="text-blue-200 text-sm mt-0.5">{{testimonial.industry}}</p>
                                    @if (testimonial.region) {
                                        <p class="text-gray-400 text-xs mt-1">{{testimonial.region}}</p>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                } @else {
                    <div class="col-span-3 text-center py-8">
                        <p class="text-gray-400">Loading testimonials...</p>
                    </div>
                }
            </div>
        </div>
    </div>

     <!-- CTA Section -->
     <div class="bg-white py-20" id="contact">
        <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="relative overflow-hidden rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 shadow-sm hover:shadow-md transition-all duration-300">
                <!-- Subtle background pattern -->
                <div class="absolute inset-0 bg-[url('/assets/images/grid-pattern.svg')] opacity-5"></div>
                
                <!-- Content container -->
                <div class="relative px-8 py-12 md:py-16">
                    <div class="text-center max-w-2xl mx-auto">
                        <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                            Ready to experience our <span class="text-blue-600">intelligence solutions</span>?
                        </h2>
                        <p class="text-gray-600 mb-8">
                            Explore our interactive demos and discover how we can transform your business decisions.
                        </p>
                        <a href="#" class="inline-flex items-center px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-all duration-300 shadow-md hover:shadow-lg focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none group">
                            Explore Our Demos
                            <svg class="ml-2 w-5 h-5 transform transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

